<div *ngIf="isLoading">
    <app-loading-spinner></app-loading-spinner>
  </div>

<div class="w-50 m-auto">
    <h2 class="my-4">Register Form</h2>
    <div *ngIf='flag' class="alert alert-danger m-auto">
        <p>This Email Is Already Exist</p>
    </div>
<form action="" [formGroup]='registerForm' (ngSubmit)='getRegisterInfo(registerForm)'>


    <div class="form-group">
        <label for="">Name :</label>
        <input [class.is-valid] = "registerForm.get('name').errors == null &&registerForm.get('name').touched" formControlName='name' type="text" class="form-control" >
        <p class="py-2 text-danger" *ngIf="registerForm.get('name').errors != null &&registerForm.get('name').touched  "  >FirstName Invalid</p>
        </div>


    
        <div class="form-group">
            <label for="">Email :</label>
            <input [class.is-valid] = "registerForm.get('email').errors == null &&registerForm.get('email').touched" formControlName='email' type="email" class="form-control">
            <p *ngIf="registerForm.get('email').errors != null &&registerForm.get('email').touched  "  class="py-2 text-danger">Email Invalid</p>
        </div>

        
        <div class="form-group">
            <label for="">Password :</label>
            <input [class.is-valid] = "registerForm.get('password').errors == null &&registerForm.get('password').touched" formControlName='password' type="password" class="form-control">
            <p *ngIf="registerForm.get('password').errors != null &&registerForm.get('password').touched  "  class="py-2 text-danger">password Invalid</p>
        </div>
        
        <div class="form-group">
            <label for="">rePassword :</label>
            <input [class.is-valid] = "registerForm.get('rePassword').errors == null &&registerForm.get('rePassword').touched" formControlName='rePassword' type="password" class="form-control">
              <div class="invalid-feedback d-block" *ngIf="registerForm&&registerForm.errors&&registerForm.errors['matchedPassword'] && registerForm.get('rePassword')?.touched">
                Please enter the same Original Password.
              </div>
    
        </div>

        
        
        <div class="form-group">
            <label for="">Phone Number :</label>
            <input [class.is-valid] = "registerForm.get('phone').errors == null &&registerForm.get('phone').touched" formControlName='phone' type="text" class="form-control">
            <p *ngIf="registerForm.get('phone').errors != null &&registerForm.get('phone').touched  " class="py-2 text-danger">Phone Invalid</p>
            </div>
            <div class="text-center mb-4">
                 <button [disabled]='registerForm.invalid' type="submit" class="btn btn-mine text-white d-inline">Register</button>
            </div>
</form>
</div>